export { default } from "./SvgIcon.js";
export { default as svgIconClasses } from "./svgIconClasses.js";
export * from "./svgIconClasses.js";